export default __webpack_public_path__ + "static/media/logo.f770525d.png";